import { formatCurrencyAmount } from './formatting';
import { IMerchant, IMerchantDetails } from 'src/common/types';
import { Offer } from 'src/context/offer-context';
import { LulalendLogo, VFSLogo } from 'src/helpers/contract-icons';

const widthInPoints = 138.33;
const heightInPoints = 28.35;

export const contractTemplate = (
  merchantDetails: IMerchantDetails,
  merchant: IMerchant,
  selectedOffer: Offer,
) => ({
  content: [
    {
      table: {
        widths: ['*', '*'],
        body: [
          [
            {
              image: VFSLogo,
              fit: [widthInPoints, heightInPoints],
              alignment: 'left'
            },
            {
              image: LulalendLogo,
              fit: [widthInPoints, heightInPoints],
              alignment: 'right'
            }
          ]
        ]
      },
      layout: 'noBorders'
    },
    { text: 'SALE AND PURCHASE AGREEMENT', style: 'title' },
    { text: '(STANDARD ONLINE VERSION)', style: 'title2' },
    {
      canvas: [
        {
          type: 'line',
          x1: 0,
          y1: 0,
          x2: 510,
          y2: 0,
          lineWidth: 2,
          linecolor: 'gray',
        },
      ],
    },
    { text: 'MERCHANT INFORMATION', style: 'heading' },
    {
      table: {
        widths: ['*', '*'],
        heights: 50,
        body: [
          [
            {
              text: [
                { text: 'Business/ Trading Name of Merchant\n\n', bold: true },
                { text: `${merchant.companyName ?? 'N/A'}` },
              ],
            },
            {
              text: [
                { text: 'Date\n\n', bold: true },
                { text: `${merchantDetails?.advanceStart ?? 'N/A'}` },
              ],
            },
          ],
          [
            {
              text: [
                { text: 'Name of Owner\n\n', bold: true },
                { text: `${merchantDetails.nameOfOwner ?? 'N/A'}` },
              ],
            },
            {
              text: [
                { text: 'Business Conducted by the Merchant\n\n', bold: true },
                { text: `${merchant.mccDescription}` },
              ],
            },
          ],
          [
            {
              text: [
                { text: 'Registration Number / Identity Number\n\n', bold: true },
                { text: `${merchant?.companyRegistrationNumber ?? merchantDetails.idNumber}` },
              ],
            },
            {
              text: [
                { text: 'Merchant Address/ Business Premises\n\n', bold: true },
                { text: `${merchantDetails.address ?? 'N/A'}` },
              ],
            },
          ],
        ],
      },
    },
    { text: 'TRANSACTION INFORMATION', style: 'heading' },
    {
      table: {
        widths: ['*', '*'],
        heights: 50,
        body: [
          [
            {
              text: [
                { text: 'Advance Amount\n\n', bold: true },
                { text: `R ${formatCurrencyAmount(selectedOffer?.Amount ?? 0)}` },
              ],
            },
            {
              text: [
                { text: 'Agreed Percentage/ Repayment Factor\n\n', bold: true },
                { text: `${selectedOffer?.Rate ?? 0} %` },
              ],
            },
          ],
          [
            {
              text: [
                { text: 'Future Revenue Total Rand Value\n\n', bold: true },
                { text: `R ${formatCurrencyAmount(selectedOffer.TotalRepayments ?? selectedOffer.TotalRepayment ?? 0)}` },
              ],
            },
            {
              text: [{ text: 'Repayment Frequency\n\n', bold: true }, { text: 'Daily' }],
            },
          ],
          [
            {
              text: [
                { text: 'Estimated Repayment Term\n\n', bold: true },
                { text: `${selectedOffer?.Term ?? 0} Months` },
              ],
            },
            {
              text: [
                { text: '', bold: false },
                {
                  text: '',
                },
              ],
            },
          ],
        ],
      },
    },
    {
      text: `THIS AGREEMENT IS CONDITIONAL UPON LULA LEND RECEIVING ALL RELEVANT DOCUMENTATION AND INFORMATION IT DEEMS NECESSARY IN ORDER TO GIVE EFFECT HERETO AND TO ENABLE LULA LEND TO CONDUCT A CREDIT ASSESSMENT ON THE MERCHANT. ACCORDINGLY, LULA LEND RESERVES ITS RIGHTS NOT TO DISBURSE THE ADVANCE AMOUNT SHOULD SUCH ASSESSMENT ILLUSTRATE A POOR CREDIT SCORING OR SHOULD THE RELEVANT DOCUMENTATION NOT BE RECEIVED. THIS AGREEMENT SHALL ONLY BE OF FORCE AND EFFECT ONCE THIS CONDITION IS FULFILLED.

      PLEASE SCROLL DOWN AND READ ALL OF THE FOLLOWING TERMS CAREFULLY. THIS DOCUMENT IS A LEGAL AGREEMENT STATING THE TERMS AND CONDITIONS THAT GOVERN THE MERCHANT’S RIGHTS AND OBLIGATIONS. YOU ARE ENTERING INTO THIS LEGAL AGREEMENT ON BEHALF OF THE MERCHANT AND REPRESENT THAT YOU HAVE THE AUTHORITY TO BIND SUCH MERCHANT TO THESE TERMS AND CONDITIONS. BY CLICKING “ACCEPT” (OR THE EQUIVALENT) OR EXERCISING ANY RIGHT GRANTED HEREIN YOU ARE AGREEING TO ALL OF THE TERMS AND CONDITIONS IN THIS AGREEMENT`,
      style: 'disclaimer'
    },
  ],
  styles: {
    title: {
      fontSize: 10,
      bold: true,
      alignment: 'center',
      margin: [0, 40, 0, 10],
    },
    title2: {
      fontSize: 10,
      bold: true,
      alignment: 'center',
      margin: [0, 0, 0, 50],
    },
    heading: {
      fontSize: 10,
      bold: true,
      alignment: 'left',
      margin: [0, 20, 0, 20],
    },
    disclaimer: {
      fontSize: 8,
      bold: true,
      alignment: 'left',
      margin: [0, 20, 0, 10],
      characterSpacing: 0.5,
    },
  },
});
